import { render, staticRenderFns } from "./RfWalletPassSelector.vue?vue&type=template&id=2d46d621&"
import script from "./RfWalletPassSelector.vue?vue&type=script&lang=js&"
export * from "./RfWalletPassSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports